import { render, staticRenderFns } from "./study-she.vue?vue&type=template&id=6b713842&scoped=true&"
import script from "./study-she.vue?vue&type=script&lang=ts&"
export * from "./study-she.vue?vue&type=script&lang=ts&"
import style0 from "./study-she.vue?vue&type=style&index=0&id=6b713842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b713842",
  null
  
)

export default component.exports